export type InfraIoErrorCode =
  | 'invalid_request_error'
  | 'iframe_load_error'
  | 'iframe_timeout_error'
  | 'already_open_error';

export class InfraIoError extends Error {
  public code: InfraIoErrorCode;

  constructor(code: InfraIoErrorCode, message: string) {
    super(message);
    this.name = 'InfraIoError';
    this.code = code;
  }
}
